<template>
    <el-form :model="rule" :rules="rules" ref="forms" class="demo-ruleForm" label-width="100px">
        <el-form-item label="姓名" prop="username">
            <el-input placeholder="请输入名称" v-model="rule.username" clearable></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
            <el-input type="password" placeholder="请输入密码" v-model="rule.password" clearable @input="change()"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="passvalid">
            <el-input type="password" placeholder="确认密码" v-model="rule.passvalid" clearable @input="change()"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="mobile">
            <el-input type="telephone" maxlength="11" placeholder="请输入手机号" v-model="rule.mobile" clearable></el-input>
        </el-form-item>
        <el-form-item label="email" prop="mail">
            <el-input type="email" placeholder="请输入email" v-model="rule.mail" clearable></el-input>
        </el-form-item>

        <el-form-item>
            <el-button type="primary" @click="submit">提交</el-button>
            <el-button @click="block">返回</el-button>
        </el-form-item>
    </el-form>
</template>

<script>
    import Vue from 'vue';
    export default {
        data() {
            var vaildpass = (rule, value, callback) => {
                if(this.rule.passvalid != this.rule.password) {
                    callback(new Error('两次密码不一致'));
                }else {
                    callback();
                }
            };
            var validPhone = (rule,value,callback) => {
                if (!/^1[3456789]\d{9}$/.test(value)) {
                    callback(new Error("请输入正确的手机号"));
                } else {
                    callback();
                }
            }
            return {
                name: 'edit',
                rule: {
                    userType:1,
                    id: 0,
                    password: '',
                    passvalid: '',
                    mobile: '',
                    username: '',
                    mail:'',
                },
                rules: {
                    mail:[
                    {required: true, message: '请输入邮箱', trigger: 'blur'},
                    ],
                    username:[
                        {required: true, message: '请输入姓名', trigger: 'blur'},
                    ],
                    password:[
                        {required: true, message: '请输入密码', trigger: 'blur'},
                        {min:3, max:32,message:'密码长度限制为3-32位',trigger:'blur'},
                    ],
                    passvalid:[
                        {required: true, message: '请输入密码', trigger: 'blur'},
                        {validator:vaildpass,trigger:'blur'},
                    ],
                    mobile: [
                        { required: true, message: '请输入手机号' },
                        {validator: validPhone,trigger:'blur'}
                    ],
                },
                selectList:[],
            }
        },
        created() {
            this.$http.post('/manage/institution/listAll').then(data => {
                    this.selectList = data['data']['data'];
                }).catch(() => {
                    this.$router.push('/customer/index');
                });
        },
        methods: {
            submit() {
                this.$refs['forms'].validate(valid => {
                    if(valid) {
                        delete this.rule.id;
                        delete this.rule.passvalid;
                        this.$http.post('/manage/customer/add',this.rule).then(rs => {
                            if(rs.data.code == 0) {
                                this.$message({
                                    message: '操作成功',
                                    type: 'success'
                                });
                                this.$router.push('/customer/individualCustomers');
                            }else {
                                this.$message({
                                    message: rs.data.message,
                                    type: 'error'
                                });
                            }
                        })
                    }
                });
            },
            block() {
                this.$router.push('/customer/index');
            },
            change(){
                //潜入太深，需要刷新
                this.$forceUpdate();
            }
        }
    }
</script>